import styled from 'styled-components';

import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Phone = styled.a`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    text-decoration: none;
`;

export const SBlockContainer = styled(BlockContainer)`
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 32px;
  
    & ${ButtonGroup} {
        flex: 1;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;
